// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cbp-tabs{display:flex;justify-content:flex-start;border-radius:4px;background-color:#fff}.cbp-tabs__tab{padding:8px 16px;border-radius:4px;margin-left:8px !important;margin-right:0;color:#00857a;font-weight:bold;cursor:pointer}.cbp-tabs__tab:first-child{margin-left:0 !important}.cbp-tabs__tab:hover{background-color:#f0f0f0}.cbp-tabs__tab.cbp-tab--selected{background-color:#37aba1;color:#fff}", ""]);
// Exports
module.exports = exports;
